import React, { useState, useEffect, useCallback } from "react"
import Select from "@material-ui/core/Select"
import { MenuItem } from "@material-ui/core"
import { getUserCompanies } from "../utils/common"

export default ({ user, onSelect, ...props }) => {
  const [company, setCompany] = useState("")
  const [companies, setCompanies] = useState([])

  const selectCompany = useCallback(
    company => {
      setCompany(company)
      onSelect && onSelect(company)
    },
    [onSelect],
  )

  useEffect(() => {
    const userCompanies = getUserCompanies(user)

    // set select options
    setCompanies(userCompanies)

    // set select values
    const storedCompany = localStorage.getItem("OMNI_SELECTED_COMPANY")
    if (storedCompany) {
      selectCompany(storedCompany)
    } else if (userCompanies.length > 0) {
      selectCompany(userCompanies[0])
    }
  }, [user, selectCompany])

  return (
    <Select
      {...props}
      value={company}
      style={{ color: '#000000 !important', height: "45px" }}
      onChange={evt => {
        const val = evt.target.value
        selectCompany(val)
      }}
    >
      {companies.map((cmpny, i) => (
        <MenuItem key={`menu-${company}-${i}`} value={cmpny}>
          {cmpny}
        </MenuItem>
      ))}
    </Select>
  )
}
